if (!customElements.get("footer-details")) {
	class FooterDetails extends AccordionDetails {
		constructor() {
			super();
		}

		connectedCallback() {
			this.openDefault = this.dataset.openDefault === "true";

			if (FoxTheme.config.mqlTablet) {
				if (!this.openDefault) this.open = false;
			}

			document.addEventListener("matchTablet", () => {
				if (!this.openDefault) {
					this.open = false;
				} else {
					this.open = true;
				}
			});

			document.addEventListener("unmatchTablet", () => {
				this.open = true;
			});
		}
	}
	customElements.define("footer-details", FooterDetails, { extends: "details" });
}

// On DOM loaded add event listener "Click" on ID : footer_cookie_link
document.addEventListener("DOMContentLoaded", () => {
	const footerCookieLink = document.getElementById("footer_cookie_link");
	if (footerCookieLink) {
		footerCookieLink.addEventListener("click", (e) => {
			e.preventDefault();
			if (window.OneTrust) {
				window.OneTrust.ToggleInfoDisplay();
			}
		});
	}
});
